/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";

/* 🧩 COMPONENTS */
import { Input, Label, Button, CustomLoading, InputCheckbox, SaveIcon } from "../../../../Components";

/* 🔗 SERVICE */
import { PartsComandServices } from "../../../../Services/partscommandService";

/* 📁 ASSETS*/
import { Excluir } from "../../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContainerRow, ContainerColumn, ImageIcon, ButtonsContainer } from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const ViewPartsCommandsVariables = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    document.title = "Edição de variável";
    const [loading, setLoading] = useState(true);

    let { id } = useParams();
    const Services = useRef(new PartsComandServices());

    const NameField = useRef();
    const abbreviationField = useRef();
    const descriptionField = useRef();
    const unitField = useRef();
    const variablemqttField = useRef();
    const databasenamevariableField = useRef();
    const typeField = useRef();

    const Namevalue = useRef();
    const abbreviationvalue = useRef();
    const descriptionvalue = useRef();
    const unitvalue = useRef();
    const variablemqttvalue = useRef();
    const databasenamevariablevalue = useRef();
    const typevalue = useRef();
    const isSwitchvalue = useRef();
    const isAlarmvalue = useRef();
    const isReadOnlyvalue = useRef();
    
    const [partCommand, setPartCommand] = useState();

    useEffect(() => {
        async function getPartCommand(){
            setLoading(true)
            let currentItem = await Services.current.getPartCommandVariable(id);
            if(currentItem){
                isSwitchvalue.current = currentItem.isSwitch;
                isAlarmvalue.current = currentItem.isAlarm;
                isReadOnlyvalue.current = currentItem.isReadOnly;
                setPartCommand(currentItem);
            }
            setLoading(false)
        }

        getPartCommand();
    }, [id]);

    // method-spoofing
    // Salva as edições
    async function Save(){
        if(isValidField(Namevalue.current)){
            let form = new FormData();
            if(Namevalue.current){form.append('name', Namevalue.current)}
            if(abbreviationvalue.current){form.append('abbreviation', abbreviationvalue.current)}
            if(descriptionvalue.current){form.append('description', descriptionvalue.current)}
            if(unitvalue.current){form.append('unit', unitvalue.current)}
            if(variablemqttvalue.current){form.append('variablemqtt', variablemqttvalue.current)}
            if(databasenamevariablevalue.current){form.append('databasenamevariable', databasenamevariablevalue.current)}
            if(typevalue.current){form.append('type', typevalue.current)}
            form.append('isSwitch', isSwitchvalue.current ? 1 : 0)
            form.append('isAlarm', isAlarmvalue.current ? 1 : 0)
            form.append('isReadyOnly', isReadOnlyvalue.current ? 1 : 0)
            form.append('_method', 'PATCH')

            let currentitem = await Services.current.editPartCommandVariable(id, form)
            if(currentitem){
                setPartCommand(currentitem);
            }
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return (
        <>  
            <Container>
                <TitleContainer>
                    <Title>{partCommand?.name}</Title>
                </TitleContainer>

                {loading ? <CustomLoading width={'150px'} height={'150px'}/>:
                <>
                    <ContainerRow onSubmit={(e)=> e.preventDefault()}>
                        <ContainerColumn>
                            <Label text={t("inputs.name.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='name' 
                                name='name' 
                                type="text" 
                                placeholder= {t("inputs.name.placeholder")}
                                innerRef={NameField}
                                value={partCommand?.name}
                                invalidMessage = {t("inputs.name.invalid-message")}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => Namevalue.current = text}> 
                            </Input>

                            <Label text={t("inputs.description.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='description' 
                                name='description' 
                                type="text" 
                                placeholder= {t("inputs.description.placeholder")}
                                innerRef={descriptionField}
                                value={partCommand?.description}
                                invalidMessage = {t("inputs.description.invalid-message")}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => descriptionvalue.current = text}> 
                            </Input>

                            <Label text={t("inputs.abbreviation.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='abbreviation' 
                                name='abbreviation' 
                                type="text" 
                                placeholder= {t("inputs.abbreviation.placeholder")}
                                innerRef={abbreviationField}
                                value={partCommand?.abbreviation}
                                invalidMessage = {t("inputs.abbreviation.invalid-message")}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => abbreviationvalue.current = text}> 
                            </Input>

                            <Label text={t("inputs.type.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='type' 
                                name='type' 
                                type="text" 
                                placeholder= {t("inputs.type.placeholder")}
                                innerRef={typeField}
                                value={partCommand?.type}
                                invalidMessage = {t("inputs.type.invalid-message")}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => typevalue.current = text}> 
                            </Input>
                            
                        </ContainerColumn>

                        <ContainerColumn>
                            <Label text={t("inputs.unit.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='unit' 
                                name='unit' 
                                type="text" 
                                placeholder= {t("inputs.unit.placeholder")}
                                innerRef={unitField}
                                value={partCommand?.unit}
                                invalidMessage = {t("inputs.unit.invalid-message")}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => unitvalue.current = text}> 
                            </Input>

                            <Label text={t("inputs.variablemqtt.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='variablemqtt' 
                                name='variablemqtt' 
                                type="text" 
                                placeholder= {t("inputs.variablemqtt.placeholder")}
                                innerRef={variablemqttField}
                                value={partCommand?.variablemqtt}
                                invalidMessage = {t("inputs.variablemqtt.invalid-message")}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => variablemqttvalue.current = text}> 
                            </Input>

                            <Label text={t("inputs.databasenamevariable.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='databasenamevariable' 
                                name='databasenamevariable' 
                                type="text" 
                                placeholder= {t("inputs.databasenamevariable.placeholder")}
                                innerRef={databasenamevariableField}
                                value={partCommand?.databasenamevariable}
                                invalidMessage = {t("inputs.databasenamevariable.invalid-message")}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => databasenamevariablevalue.current = text}> 
                            </Input>

                            <InputCheckbox text={t("inputs.isSwitch.label")} checked={partCommand?.isSwitch} onChange={(value)=> {isSwitchvalue.current = value; return true}}/>
                            <InputCheckbox text={t("inputs.isAlarm.label")} checked={partCommand?.isAlarm} onChange={(value)=> {isAlarmvalue.current = value; return true}}/>
                            <InputCheckbox text={t("inputs.isReadOnly.label")} checked={partCommand?.isReadyOnly} onChange={(value)=> {isReadOnlyvalue.current = value; return true}}/>
                        </ContainerColumn>
                    </ContainerRow>

                    <ButtonsContainer>
                        <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={()=>Save()}/>
                        <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} onClick={async function(){
                            await Services.current.deletePartCommandVariable(id);
                            navigate("/PartCommandsVariables")
                        }} icon={<ImageIcon src={Excluir}/>}/>
                    </ButtonsContainer>
                </>}

            </Container>
        </>
    );
}

export default ViewPartsCommandsVariables;